// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__PLSta","navbar":"Admin_navbar__gh3h2","content":"Admin_content__awTNf"};